// @flow weak

import React, { Component } from 'react';
import Spinner               from 'react-spinkit';

// Wraps a webpack `import()` in a component. This app is on React 15, which
// predates React.lazy()/Suspense, so chunk-loading has to be done by hand.
export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    state = { Component: null };

    componentDidMount() {
      importComponent().then(module => {
        this.setState({ Component: module.default });
      });
    }

    render() {
      const { Component } = this.state;
      if (!Component) {
        return (
          <div className="loading-overlay">
            <Spinner name="ball-grid-pulse" color="darkturquoise" />
          </div>
        );
      }
      return <Component {...this.props} />;
    }
  }

  return AsyncComponent;
}



// WEBPACK FOOTER //
// ./src/app/components/asyncComponent/index.js